import React from "react"

import { Heading } from "@/components/ProfileSection/Heading"
import { RoleInfo } from "@/components/ProfileSection/RoleInfo"
import { TextInfo } from "@/components/ProfileSection/TextInfo"
import { AssociationCard } from "@/components/ProfileSection/AssociationCard"

import { useStyles } from "@/components/ProfileSection/ProfileSection.styles"

interface ProfileSectionProps {
    children: React.ReactNode
    className?: string | string[]
}

export const ProfileSection = ({ children, className }: ProfileSectionProps) => {
    const { classes, cx } = useStyles()

    return <section className={cx(classes.section, className)}>{children}</section>
}

ProfileSection.Heading = Heading
ProfileSection.RoleInfo = RoleInfo
ProfileSection.TextInfo = TextInfo
ProfileSection.AssociationCard = AssociationCard
